import React, { useEffect, useState } from 'react';
import { TrendingUp, MapPin, Info, Loader2 } from 'lucide-react';
import { supabase } from '../supabase';

interface Stats {
  avg_price_per_sqm: number | null;
  transactions_count: number | null;
  data_period: string | null;
}

type LoadState = 'loading' | 'done';

interface Props {
  city: string;
  neighborhood: string;
}

export default function NeighborhoodInsights({ city, neighborhood }: Props) {
  const [loadState, setLoadState] = useState<LoadState>('loading');
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    console.log('Property city:', city);
    console.log('Property neighborhood:', neighborhood);

    setLoadState('loading');
    setStats(null);

    if (!city) {
      setLoadState('done');
      return;
    }

    let cancelled = false;

    supabase
      .from('market_neighborhood_stats')
      .select('avg_price_per_sqm, transactions_count, data_period')
      .eq('city', city.trim())
      .eq('neighborhood_name', (neighborhood || '').trim())
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return;
        console.log('Neighborhood query result:', { data, error });
        setStats(data ?? null);
        setLoadState('done');
      });

    return () => { cancelled = true; };
  }, [city, neighborhood]);

  return (
    <div className="mt-3 pt-3 border-t border-gray-600">
      <div className="flex items-center gap-2 mb-2">
        <TrendingUp size={13} className="text-blue-400 shrink-0" />
        <span className="text-xs font-bold text-blue-400 tracking-wide">תובנות שכונה</span>
      </div>

      {loadState === 'loading' ? (
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <Loader2 size={12} className="animate-spin shrink-0" />
          <span>טוען מידע...</span>
        </div>
      ) : (
        <div className="space-y-1">
          {city && (
            <div className="flex items-center gap-2 text-xs">
              <MapPin size={11} className="text-gray-500 shrink-0" />
              <span className="text-gray-400">עיר:</span>
              <span className="text-gray-200">{city}</span>
            </div>
          )}
          {neighborhood && (
            <div className="flex items-center gap-2 text-xs">
              <MapPin size={11} className="text-gray-500 shrink-0" />
              <span className="text-gray-400">שכונה:</span>
              <span className="text-gray-200">{neighborhood}</span>
            </div>
          )}
          {stats?.avg_price_per_sqm != null ? (
            <div className="flex items-center gap-2 text-xs mt-1">
              <TrendingUp size={11} className="text-green-400 shrink-0" />
              <span className="text-gray-400">מחיר ממוצע למ״ר:</span>
              <span className="text-green-300 font-medium">
                ₪{Math.round(stats.avg_price_per_sqm).toLocaleString('he-IL')}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-xs mt-1">
              <Info size={11} className="text-gray-500 shrink-0" />
              <span className="text-gray-500 italic">מידע שוק יתווסף בהמשך</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
